import React, { memo } from "react";

// components
import CartProduct from "components/Carts/CartProduct";

// Type
import { TItem } from "../type";

// Interface
interface IListImpurities {
  data?: TItem[];
}

export const ListImpurities: React.FC<IListImpurities> = (props) => {
  const { data= [] } = props;

  return data?.length ? <div className="mb30">
    {data?.map((item) => <CartProduct
      {...item.compound}
      type="compounds"
      className="mb10"
      key={crypto.randomUUID()}
      outDescription={item.description}
    />)}
  </div> : <></>;
};

export default memo(ListImpurities);
